<template>
  <div class="flex flex-col w-full items-center gap-2 p-2">
    <div v-if="sponsor.logo" class="flex items-center gap-1 w-[400px] h-[200px]">
      <img v-if="sponsor.logo"
           :src="img(sponsor.logo, { width: 400, height: 200, fit: 'inside' })"
           :alt="sponsor.name"/>
    </div>
    <h2 v-else>{{ sponsor.name }}</h2>
    <div v-if="sponsor.content" class="flex items-center gap-1">
      <div v-html="sponsor.content"></div>
    </div>
    <div class="w-full flex flex-col items-start justify-center gap-1">
      <p v-if="sponsor.address">{{ sponsor.address }}</p>
      <a v-if="sponsor.url" :href="sponsor.url" target="_blank" class="text-theme-primary">Webseite</a>
    </div>
    <div class="w-full border border-dashed p-1">
      <p class="text-sm">{{ sponsor.name }} {{ $t('map_sponsor.support_text') }}<br>
        <a :href="'mailto:'+contactEmail"
          class="text-sm text-theme-primary"
      >{{
          $t('map_sponsor.become_sponsor_text')
        }}</a></p>

    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{ sponsor: MapSponsor }>();
const {getThumbnail: img} = useDirectusFiles();
const contactEmail = usePlatformSettings().getContactEmail();
</script>
